import { FetchGuestNotificationsQuery } from '@website/types/graphqlOperations';
import pluralize from 'pluralize';
import composeNotificationActorsPrefix from './composeNotificationActorsPrefix';

export default function composeOutgoingNotificationMessageForGroup(
  activities: FetchGuestNotificationsQuery['user']['notifications']['items'],
): { message: string; url: string } {
  const { type, object, target, url } = activities[0];
  const pluralizeObject = pluralize(object.name, activities.length, true);
  const actorsPrefix = composeNotificationActorsPrefix(activities);
  return {
    message: `${actorsPrefix} ${type} ${pluralizeObject} ${target?.name || ''}`,
    url,
  };
}
